<template>
  <div>
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("account.myOrders") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("account.myOrders") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("account.myOrders") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="custom_page_content">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 column">
            <div class="categories-widget marginb20 card card-padding">
              <div class="title-line">
                <h5 class="sidebar-title">{{ $t("account.myOrders") }}</h5>
                <hr />
              </div>
              <ul class="list-style-2 list-style">
                <li>
                  <a href="javascript:;" @click="status = undefined">{{ $t("account.all") }}</a>
                </li>
                <li>
                  <a href="javascript:;" @click="status = 0">{{ $t("account.unpaid") }}</a>
                </li>
                <li>
                  <a href="javascript:;" @click="status = 2">{{ $t("account.waitingForDelivery") }}</a>
                </li>
                <li>
                  <a href="javascript:;" @click="status = 3">{{ $t("account.deliver") }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-9 column">
            <p v-if="loading" class="text-muted" style="text-align: center">{{ $t("account.loading") }}...</p>
            <ul v-if="orderList.length" class="media-list">
              <li v-for="(item, i) in orderList" :key="i" class="media">
                <div class="media-left">
                  <img class="media-object" :src="item.cover" :alt="item.productName" />
                </div>
                <div class="media-body">
                  <div class="row">
                    <div class="col-xs-12 col-sm-7">
                      <h4 class="media-heading text-overflow" :title="item.productName">{{ item.productName }}</h4>
                    </div>
                    <div class="col-xs-12 col-sm-5">{{ $t("account.orderNo") }}: {{ item.orderNo }}</div>
                  </div>
                  <div class="row margint20">
                    <div class="col-xs-12 col-sm-5">
                      <template v-if="item.parameters && item.parameters.length">
                        <div v-for="(it, i) in item.parameters" :key="i">
                          <label style="font-weight: 400">
                            - {{ it.parameterName }}
                            <span style="margin-left: 20px; font-weight: 400">Price({{ item.currency }}): {{ it.price }}</span>
                          </label>
                        </div>
                      </template>
                      <div key="a">
                        <label style="font-weight: 400">
                          - {{ $t("account.postage") }}
                          <span style="margin-left: 20px; font-weight: 400">Price({{ item.currency }}): {{ item.postage || 0 }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-1">X{{ item.productNum }}</div>
                    <div class="col-xs-6 col-sm-1">${{ item.totalPrice }}</div>
                    <div class="col-xs-6 col-sm-2">{{ orderStatus[item.status] }}</div>
                    <div class="col-xs-6 col-sm-3">{{ item.createTime }}</div>
                    <div class="col-xs-12 col-sm-12" style="margin: 20px 0; margin-left: 20px">
                      <button v-if="item.status == 0" :disabled="item.loading" @click="toPay(item)" type="button" class="btn btn-primary">{{ $t("account.toPay") }}</button>
                      <button v-if="item.status == 3" :disabled="item.loading" @click="logisticsInfo(item)" type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal">{{ $t("account.logistics") }}</button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <p v-if="!orderList.length && !loading" class="text-muted" style="text-align: center">{{ $t("account.empty") }}</p>

            <nav v-if="total > page.per_page" aria-label="Page navigation" style="text-align: right; margin-top: 30px">
              <ul class="pagination">
                <li :class="{ disabled: page.page === 1 }" key="a">
                  <a href="javascript:;" aria-label="Previous" @click="page.page !== 1 && page.page++">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li v-for="(item, i) in Math.ceil(total / page.per_page)" :key="i" :class="{ active: page.page === item }">
                  <a href="javascript:;" @click="page.page = item">{{ item }}</a>
                </li>
                <li :class="{ disabled: page.page === Math.ceil(total / page.per_page) }" key="b">
                  <a href="javascript:;" aria-label="Next" @click="page.page !== Math.ceil(total / page.per_page) && page.page++">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div>
        <!-- Button trigger modal -->
        <!-- Modal -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">{{ $t("account.logistics") }}</h4>
              </div>
              <div class="modal-body">
                <div class="table_page">
                  <ul class="uls">
                    <li >
                      <!-- <h5 style="height: 50px">{{ $t("account.logistics") }}</h5> -->
                      <div class="steps-container" v-if="logistics.length">
                        <div class="step" v-for="(item,index) in logistics" :key="index">
                          <div class="step-line1" v-if="index !== logistics.length-1" :class="index == 0 ?'actives':'normal'"></div>
                          <div class="step-circle1" :class="index == 0 ?'actives':'normal'"></div>
                          <div class="time" :class="index == 0 ?'activeColor':''">
                            <span style="font-size: 15px;font-weight: 800;">{{ item.status }}</span>
                            &nbsp;
                            <span style="font-size: 15px;font-weight: 800;">{{ item.timeUtc }} </span>
                          </div>
                          <div :class="index == 0 ?'activeColor':''"><span id="createTime">{{ item.address }}</span></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t("account.close") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch, computed } from "vue";
import { getIndependentOrder,getLogisticsInfo } from "@/utils/api";
import i18n from "@/i18n";
import { payment } from "@/utils/api";

const toPay = async (order) => {
  order.loading = true;
  await payment({ orderNo: order.orderNo, cancelUrl: window.location.origin + "/OrderList", successUrl: window.location.origin + "/OrderList", money: 100 }).then((res) => {
    if (res.data) window.location.href = res.data;
  });
};

const number=ref('')
const logisticsInfo = (item) => {
  logistics.value=[]
  number.value=item.number
  getLogisticsInfo({ page: page, number: number.value }).then(res=>{
    if(res.code=='000000'){
      logistics.value = res.data.list;
    }else{
      logistics.value=[]
    }
   
  })
};
const orderStatus = computed(() => {
  return {
    0: i18n.t("account.unpaid"),
    1: i18n.t("account.waitingForDelivery"),
    3: i18n.t("account.deliver"),
  }
});

const orderList = ref([]);
const status = ref();
const total = ref(0);
const loading = ref(true);
const page = reactive({ page: 1, per_page: 10 });
const logistics = ref([]);
const getOrderList = () => {
  loading.value = true;
  orderList.value = [];
  getIndependentOrder({ page: page, status: status.value }).then((res) => {
    res.data.list.forEach((order) => {
      order.loading = false;
    });
    loading.value = false;
    orderList.value = res.data.list;
    total.value = res.data.total;
  });
};
onMounted(() => {
  getOrderList();
});

watch([status, page], () => {
  getOrderList();
});
</script>

<style scoped>
.actives{
  background-color: chocolate !important;
}
.normal{
  background-color: #9d9d9d;
}
.activeColor{
  color: chocolate !important;
}
.media {
  margin-top: 25px;
}
.media-body {
  border-bottom: 1px solid #f1f2f3;
}
.media-object {
  max-width: initial;
  width: 104px;
  height: 104px;
}
.custom_page_content ol,
.custom_page_content ul {
  padding-left: 0;
}
.media-heading {
  line-height: 24px;
  max-width: 650px;
}
.modal-body{
  max-height: 600px;
  overflow-y: scroll;
}
.uls li {
  margin-left: 5px;
  margin-bottom: 10px;
  list-style: none;
}

.goodsInfo {
  float: left;
}

#index_text {
  font-size: 16px;
  margin-top: -70px;
}
/*---- 订单进度 ----*/
.steps-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
}

.step {
  position: relative;
  width: 100%;
  padding-bottom: 20px;
  padding-left: 70px; /* 圆点左侧的间距 */
}

.step.active .step-circle {
  background-color: teal;
  color: #fff;
}

.step-line1 {
  position: absolute;
  top: 10px;
  left: 30px; /* 线条左侧的位置 */
  width: 2px;
  height: 100%;
  background-color: #9d9d9d;
  /* z-index: -1; 线条位于圆点下方 */
}


.step:last-child .step-line {
  display: none; /* 最后一个步骤不需要线条 */
}

.step-circle1 {
  position: absolute;
  left: 20px;
  top: 20px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background-color: #9d9d9d;
  text-align: center;
  font-size: 10px;
  color: #fff;
}



.step.active .step-circle {
  background-color: teal;
  color: #fff;
}

.time {
  height: 50px;
  font-size: 50px;
}

.time span {
  width: 100px;
  font-size: 14px;
}
</style>
